import React from 'react';
import { Container } from 'react-bootstrap';
import { FaClock, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';

const ContactNavbar = () => {
  return (
    <div className="contact-ribbon">
      <Container className="contact-ribbon__inner">
        <div className="contact-ribbon__summary">
          <span className="contact-ribbon__summary-item">
            <FaMapMarkerAlt aria-hidden="true" />
            <span>Spixworth, Norwich and surrounding areas</span>
          </span>
          <span className="contact-ribbon__summary-item">
            <FaClock aria-hidden="true" />
            <span>Mon to Fri, 7:30 AM to 5:00 PM</span>
          </span>
        </div>

        <div className="contact-ribbon__actions">
          <a className="contact-ribbon__link" href="tel:+447969087406">
            <FaPhoneAlt aria-hidden="true" />
            <span>Ben: 07969 087406</span>
          </a>
          <a className="contact-ribbon__link" href="tel:+447854826914">
            <FaPhoneAlt aria-hidden="true" />
            <span>Ian: 07854 826914</span>
          </a>
        </div>
      </Container>
    </div>
  );
};

export default ContactNavbar;
